import styled from 'styled-components';
import banner from '~/assets/banners/banner-verificar.png';

interface IBanner {
  banner: string;
}

export const Container = styled.div<IBanner>`
  min-height: 100dvh;
  background-color: #fff;
  h1 {
    color: #ff6900;
    font-size: 26px;
  }

  h2 {
    color: #ff6900;
    font-family: 'Poppins';
  }

  span {
    color: #000;
    font-size: 12px;
    font-weight: 400;
  }

  label span {
    color: #292623;
    font-size: 14px;
    font-weight: 400;
  }

  h4 {
    color: #878787;
    line-height: normal;
    font-size: 14px;
    font-weight: 400;
  }

  p {
    color: #878787;
    font-family: 'Roboto';
    font-size: 13px;
    font-weight: 400;
  }

  .error {
    display: block;
    text-align: center;
  }

  .border-ticket {
    border-radius: 8px;
    border: 1px solid #e1e1e1;

    background: #fff;
  }

  .banner {
    background-image: url(${(props) => props.banner});
    height: 72px;
    width: 100%;
    border-radius: 8px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  .btn-login {
    border-radius: 4px;
    background-color: #ff6900;
    color: #fff;
    position: sticky;
    bottom: 16px;
    width: 100%;
  }

  .bd-input {
    border: 1px solid #e1e1e1;
    height: 40px;
    border-radius: 4px;

    input {
      width: 100%;
      flex: 1;
      background: transparent;
      border: 0;
      color: #000;
      transition-duration: 0.2s;

      ::placeholder {
        color: #8c8c8c;
      }
    }
    svg:not(.check-icon, .rotate-arrow) {
      display: none;
    }
  }

  .select-tam input {
    font-size: 16px;
  }

  .bg-information {
    border-radius: 8px;
    background: #f6f6f6;
    padding: 16px;
  }
  .bg-white {
    border-radius: 8px;
  }
`;
